import _ from "lodash";
import {
  checkStatus,
  parseJSON,
  getApiUrl,
  getHeaderForAjax,
} from "./ServiceHelper";
import { getLoggedInUser } from "./AuthenticationService";
import moment from "moment";

export function getOwnRecipes(cat) {
  let category = cat ? cat : "03";
  const userId = getLoggedInUser()._id;
  if (category == "999") {
    return fetch(getApiUrl() + "/users/" + userId + "/myrecipes/", {
      method: "GET",
      headers: getHeaderForAjax(),
    })
      .then(checkStatus)
      .then(parseJSON);
  } else {
    return fetch(getApiUrl() + "/users/" + userId + "/kit/" + category, {
      method: "GET",
      headers: getHeaderForAjax(),
    })
      .then(checkStatus)
      .then(parseJSON);
  }
}

// Recipe filter for filter recipe by name, ingredient name, etc
export const recipeFilter = (key) => (recipe) => {
  if (recipe.recipe && _.includes(recipe.recipe.toLowerCase(), key)) {
    return recipe;
  }
  if (recipe.fullname && _.includes(recipe.fullname.toLowerCase(), key)) {
    return recipe;
  }
  if (recipe.cuisine && _.includes(recipe.cuisine.toLowerCase(), key)) {
    return recipe;
  }
};

export function deleteRecipes(ids, cat) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/kit/" + cat + "/" + ids; //users/04200000271/kit/03/20005200124
  if (cat == "999") {
    url = getApiUrl() + "/users/" + userId + "/recipes/" + ids;
  }
  return (
    fetch(url, {
      method: "delete",
      headers: getHeaderForAjax(),
      body: ids,
    })
      .then(checkStatus)
      .then((res) => {
        return ids;
      })
      .catch((error) => console.log(error))
  );
}

export function updateRating(id, rating, cat) {
  const userId = getLoggedInUser()._id;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/kit/" +
    cat +
    "/" +
    id +
    "/rate/" +
    rating; //users/04200000271/kit/03/20005200136/rate/2
  if (cat === "999") {
    url =
      getApiUrl() + "/users/" + userId + "/recipes/" + id + "/rate/" + rating;
  }
  return (
    fetch(url, {
      method: "put",
      headers: getHeaderForAjax(),
    })
      .then(checkStatus)
      .then(() => {
        return { id: id, rating: rating };
      })
  );
}

export function updateRank(id, rank, rankBefore, cat) {
  const userId = getLoggedInUser()._id;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/kit/" +
    cat +
    "/" +
    id +
    "/rank/" +
    rank;
  if (cat === "999") {
    url = getApiUrl() + "/users/" + userId + "/recipes/" + id + "/rank/" + rank;
  }
  return (
    fetch(url, {
      method: "PUT",
      headers: getHeaderForAjax(),
    })
      .then(checkStatus)
      .then(() => {
        return { id: id, rank: rank, rankBefore: rankBefore };
      })
  );
}
export function saveRecipe(recipe, id) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/kit/" + recipe.category;
  if (recipe.category == "999") {
    url = getApiUrl() + "/users/" + userId + "/recipes";
  }
  let method = "post";
  if ((!(recipe._id === undefined) && recipe._id !== "") || id) {
    url = id ? url + "/" + id : url + "/" + recipe._id;
    method = "put";
  }
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(recipe),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function createCuisine(cuisine) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/recipes/cuisines";
  return fetch(url, {
    method: "POST",
    headers: getHeaderForAjax(),
    body: JSON.stringify(cuisine),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function createMeasurement(measurement) {
  const userId = getLoggedInUser()._id;
  let url = getApiUrl() + "/users/" + userId + "/recipes/measurements";
  return fetch(url, {
    method: "POST",
    headers: getHeaderForAjax(),
    body: JSON.stringify(measurement),
  }).then(checkStatus);
}

export function getIngredients(recipe) {
  let url =
    getApiUrl() + "/users/" + getLoggedInUser()._id + "/getitem/" + recipe.id;

  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export function searchIngredients(input) {
  const userId = getLoggedInUser()._id;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/recipes/keywordCustom/1111/" +
    input +
    "/1";
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => {
      let arrRecipes = [];
      for (const item of data) {
        arrRecipes.push(item.recipe_full);
      }
      return arrRecipes;
    });
}

export function searchRecipes(input) {
  const userId = getLoggedInUser()._id;
  let url =
    getApiUrl() +
    "/users/" +
    userId +
    "/recipes/keywordCustom/0011/" +
    input +
    "/1";
  return fetch(url, {
    method: "GET",
    headers: getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      let data = {
        show: [],
        data: [],
      };
      for (const item of res) {
        data.data.push({ id: item._id, value: item.recipe });
        data.show.push(item.recipe);
      }
      return data;
    });
}

export function addMealPlanService(mPlan, mealListAll, history) {
  const userId = getLoggedInUser()._id;
  function vFilter(meal) {
    let result = [];
    mealListAll.forEach((element) => {
      if (mPlan.mPlanmeal.toLowerCase() == meal) {
        result.push({ _id: element.id, recipe: element.recipe });
      }
    });
    return result;
  }
  const time = moment(mPlan.mPlanDate).startOf("day");
  const body = {
    date: time.unix() * 1000,
    breakfast: vFilter("breakfast"),
    lunch: vFilter("lunch"),
    dinner: vFilter("dinner"),
    supper: vFilter("supper"),
    snack1: vFilter("snack1"),
    snack2: vFilter("snack2"),
    snack3: vFilter("snack3"),
  };
  let url = getApiUrl() + "/users/" + userId + "/mealplans";
  let method = "post";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((data) => ({ data, time, history }));
}
export async function shareService(cat, shareIds, email) {
  if (cat === "999") {
    cat = "02";
  } else if (cat === "02") {
    cat = "10";
  }

  const userId = getLoggedInUser()._id;
  let url =
    getApiUrl() + "/users/" + userId + "/share/" + cat + "?email=" + email;
  const body = {
    ids: shareIds,
  };
  let method = "post";
  return fetch(url, {
    method: method,
    headers: getHeaderForAjax(),
    body: JSON.stringify(body),
  })
    .then(checkStatus)
    .then(parseJSON);
}

export async function checkUsedRecipes(recipe) {
  const user = await getLoggedInUser();
  const userId = user._id;
  let url = getApiUrl() + "/users/" + userId + "/recipes/" + recipe + "/check/";
  return fetch(url, {
    method: "GET",
    headers: await getHeaderForAjax(),
  })
    .then(checkStatus)
    .then(parseJSON)
    .then((res) => {
      return res;
    });
}



// WEBPACK FOOTER //
// ./src/services/RecipeService.js